import React from 'react';
import { CustomerValidationWrapper } from './CustomerValidationStyled';
import { Box } from "@mui/material";

const CustomerValidation = ({ customers }) => {
  return (
    <CustomerValidationWrapper className="customerStatus">
      <Box className="d-flex">
        {customers.map((customer, index) => (
          <div className="customerDetails" key={index}>
          {customer.icon && (
            <div className="imgIcon">
             
              <img src={customer.icon} alt="img" />
            </div>
          )}
            <div className="contentUser">
              <h4>{customer.title}</h4>
              <p   className={`para${index}`}>{customer.description}</p>
            </div>
          </div>
        ))}

       
      </Box>
    </CustomerValidationWrapper>
  );
};

export default CustomerValidation;
